export default "__VITE_ASSET__PZ7jOBSK__"